const getDayWithSuffix = (date) => {
	const d = date?.getDate();
	if (d > 3 && d < 21) return `${d}th`;
	switch (d % 10) {
		case 1: return `${d}st`;
		case 2: return `${d}nd`;
		case 3: return `${d}rd`;
		default: return `${d}th`;
	}
};

export const initialTabs = [
	{
		value: 'periodWise',
		label: 'Time',
	},
	{
		value: 'productGroupWise',
		label: 'Product',
	},
	{
		value: 'geographyWise',
		label: 'Geography',
	},
];

export const initialDataFilterTabs = [
	{
		value: 'PerHour',
		label: 'Per Hour',
		condition: (data) => {
			return data.tab === 'periodWise' && data.selectedTimeFilter === 'day';
		},
	},
	{
		value: 'Cummulative',
		label: 'Cummulative',
		condition: (data) => {
			return data.tab === 'periodWise' && data.selectedTimeFilter === 'day';
		},
	},
];

export const initialChartTabs = [
	{
		value: 'TotalWeight',
		label: 'Total Weight',
	},
	{
		value: 'TotalCost',
		label: 'Total Cost',
	},
	{
		value: 'TotalCount',
		label: 'Total Count',
	},
	{
		value: 'labour',
		label: 'Labour (Dummy)',
	},
];
export const timeFilter = [
	{
		value: 'year',
		label: 'Year',
	},
	{
		value: 'month',
		label: 'Month',
	},
	{
		value: 'day',
		label: 'Day',
		disable: true,
		tagList: [
			{
				label: 'Live',
				color: 'red',
				condition: (val, selectedYear) => {
					return val === getDayWithSuffix(new Date()) && selectedYear === new Date().getFullYear();
				},
			},
		],
	},
];

export const timeFilterProduct = [
	{
		value: 'brand',
		label: 'Brand',
	},
	{
		value: 'category',
		label: 'Category',
	},
	{
		value: 'subCategory',
		label: 'SubCategory',
	},
];
export const timeFilterGeography = [
	{
		value: 'store',
		label: 'Kitchen',
	},
	{
		value: 'section',
		label: 'Section',
	},
	{
		value: 'process',
		label: 'Process',
	},
];
